module.exports = __webpack_public_path__ + "static/media/mk.ed091b88.svg";